<div fxLayout="column" fxFlexFill fxLayoutGap="6px">

  <section fxLayout="column" fxLayoutGap="8px">

    <p>You will not be able to do the following:</p>

    <ul>
      <li>Bulk updates</li>
      <li>Teacher actions</li>
      <li>Student actions</li>
      <li>Join as actions</li>
      <li>Add/edit Collections</li>
      <li>Add users</li>
      <li>Add/edit schools</li>
      <li>Action changes</li>
      <li>Add new sync jobs</li>
      <li>Upload new files</li>
      <li>Add new Guardians</li>
    </ul>

  </section>

</div>
